import { render, staticRenderFns } from "./characterList.vue?vue&type=template&id=9911667a&"
import script from "./characterList.vue?vue&type=script&lang=js&"
export * from "./characterList.vue?vue&type=script&lang=js&"
import style0 from "./characterList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports